import { createUseStyles } from 'react-jss';
import { mechaColours } from '../mecha_styles';

export const useStyles = createUseStyles({
    mecha_input_field: ({ isXs, errorState }) => ({
        backgroundColor: mechaColours.backgroundWhite,
        color: mechaColours.greyDisabledText,
        borderColor: mechaColours.lightBlue300,
        border: '1px solid',
        borderRadius: '8px',
        width: '100%',
        padding: '16px',
        maxHeight: '56px',
        height: isXs ? '48px' : '56px',
        fontSize: '16px',
        outline: 'none',
        '&:not(:placeholder-shown)': {
            borderColor: errorState ? mechaColours.redMain : mechaColours.primaryMediumBlue,
            color: errorState ? mechaColours.redMain : mechaColours.primaryMediumBlue,
            border: '2px solid'
        },
        '&:focus': {
            borderColor: errorState ? mechaColours.redMain : mechaColours.primaryDarkBlue,
            color: errorState ? mechaColours.redMain : mechaColours.primaryDarkBlue,
            border: '2px solid'
        }
    }),
    input_field_wrapper: {
        display: 'inline-block',
        position: 'relative',
        overflow: 'hidden'
    },
    input_field_span: {
        position: 'absolute',
        top: '2px',
        right: '22px'
    }
});
